import { createContext, useContext, useEffect, useState } from "react";

const MusicContext = createContext(null);

export const MusicProvider = ({ children }) => {
  const [isClose, setIsClose] = useState(false);
  const [isCLickSkip ,setIsClickSkip] = useState(false);

  // Music State
  // const [duration, setDuration] = useState();
  // const [currentTime, setCurrentTime] = useState();
  const [onLoadMeta, setOnloadMeta] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isInMusic, setIsInMusic] = useState(true);

  const [play, setPlay] = useState(false);
  const [musicId, setMusicId] = useState(null);
  const [data, setData] = useState(null);
  const [musicRef, setMusicRef] = useState(null);
  const [secMusicRef, setSecMusicRef] = useState(null);
  const [skip, setSkip] = useState(0);

  // Add a new state for the playlist and current index
  const [playlist, setPlaylist] = useState([]);
  const [dummyPlayList, setDummyPlayList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(null);

  const [musicType, setMusicType] = useState("one");

  // control popup state
  const [isPopUpRemove, setIsPopUpRemove] = useState(false);
  // const [leftButton, setleftButton] = useState(false);

  //Music data
  const [song, setSong] = useState({
    title: "",
    artist: "",
    url: "",
    image: "",
  });

  const setMusicData = (data) => {
    setData(data);
  };

  const setClose = () => {
    setIsClose(true);
  };

  const pauseAudio = () => {
    setPlay(false);
    musicRef?.current.pause();
  };

  const playAudio = () => {
    setPlay(true);
    musicRef?.current.play();
  };

  const reset = () => {
    setData(null);
    setIsClose(false);
    // setDuration();
    // setCurrentTime()
    setOnloadMeta(null);
    setProgress(0);
    setPlay(false);
  };

  const toggleAudio = () => {
    if (play) {
      musicRef.current.pause();
    } else {
      musicRef.current.play();
    }
    setPlay(!play);
  };

  // Function to set the playlist
  const setMusicPlaylist = (newPlaylist) => {
    setPlaylist(newPlaylist);
  };

  // Function to play the next track
  const playNextTrack = () => {
    if (currentIndex < playlist.length - 1) {
      let currentData = playlist[currentIndex + 1];
      setPlay(true);
      setCurrentIndex(currentIndex + 1);
      setData(currentData.audio_url);
      setSong({
        title: currentData.title,
        artist: currentData.desc,
        audio_url: currentData.audio_url,
        id: currentData.id,
        image: currentData.image,
        route : `/music/detail/songs/${currentData.id}`,
      });
      setSkip((value) => value + 1);
      setIsClickSkip(true);
    } else {
      // End of the playlist, you can handle this case (e.g., loop back to the beginning)
      // For simplicity, let's stop playing
      reset();
    }
  };


  // Function to play the previous track
  const playPreviousTrack = () => {
    if (currentIndex > 0) {
      // setCurrentIndex(currentIndex - 1);
      // setData(playlist[currentIndex - 1].audio_url);
      let currentData = playlist[currentIndex - 1];
      setPlay(true);
      setCurrentIndex(currentIndex - 1);
      setData(currentData?.audio_url);
      setSong({
        title: currentData.title,
        artist: currentData.artist,
        audio_url: currentData.audio_url,
        id: currentData.id,
        image: currentData.image,
        route : `/music/detail/songs/${currentData.id}`,
      });
      setSkip((value) => value + 1);
      setIsClickSkip(true);
    } else {
      // Already at the beginning of the playlist, you can handle this case (e.g., do nothing)
      // For simplicity, let's stop playing
      reset();
    }
  };

  // pause the audio when change music url
  useEffect(() => {
    musicRef?.current.play();
  }, [data]);

  // useEffect(() => {
  //   console.log('dummyPlayList',dummyPlayList);
  //   console.log('playlist',playlist);
  // }, [dummyPlayList])

  const changeDummyToPlaylist = () => {
    if(dummyPlayList.length > 0) {
      setMusicPlaylist(dummyPlayList);
      setDummyPlayList([]);
    }
  }

  return (
    <MusicContext.Provider
      value={{
        data,
        isClose,
        // duration,
        // currentTime,
        musicRef,
        onLoadMeta,
        progress,
        play,
        isInMusic,
        song,
        musicId,
        secMusicRef,
        setSecMusicRef,
        setMusicId,
        musicType,
        setMusicType,
        // isVisible,
        // leftButton,
        // setIsVisible,
        // setleftButton,
        changeDummyToPlaylist,
        pauseAudio,
        playAudio,
        setPlay,
        setSong,
        setIsInMusic,
        setData,
        toggleAudio,
        skip, 
        setSkip,
        // handleProgressBarClick,
        setMusicRef,
        setMusicData,
        setClose,
        reset,
        isPopUpRemove,
        setIsPopUpRemove,
        // setDuration,
        // setCurrentTime,
        playlist,
        currentIndex,
        setCurrentIndex,
        setMusicPlaylist,
        playNextTrack,
        playPreviousTrack,
        dummyPlayList,
        setDummyPlayList,
        setIsClickSkip,
        isCLickSkip
      }}
    >
      {children}
    </MusicContext.Provider>
  );
};

export const useMusic = () => {
  return useContext(MusicContext);
};
